<nav class="nav nav-secondary mixed-loyalty-nav my-0">
  <a
    attr.aria-label="{{ 'rewards.nav.featured.screenreader' | translate }}"
    class="nav-item"
    [routerLink]="['/rewards/raffles']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'rewards.nav.rewards.raffles' | translate }} </label>
  </a>
  <a
    attr.aria-label="{{ 'rewards.nav.featured.screenreader' | translate }}"
    class="nav-item"
    [routerLink]="['/rewards/events']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label>{{ 'rewards.nav.rewards.events' | translate }} </label>
  </a>
  <ng-container *ifScreenSize="screenType.Desktop">
    <a
      class="nav-item"
      [routerLink]="['/rewards/wallet']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.wallet.screenreader' | translate : { fgbdefault: 'Move to Wallet page' } }}"
    >
      <label>{{ 'rewards.nav.wallet' | translate }}</label>
    </a>
  </ng-container>
</nav>
